import * as React from "react";
import { cn } from "../../lib/utils";

function Label({ className, ...props }) {
    return (
        <label
            className={cn("text-white text-sm font-medium", className)}
            {...props}
        />
    );
}

export { Label };
